import { useContext } from 'react';

import { ProjectStatsTimeframe } from 'modules/projects/types';

import { ProjectStatsContext } from '../const';

export interface IUseProjectStatsParamsProps {
  timeframe: ProjectStatsTimeframe;
}

export const useProjectStatsParams = ({
  timeframe,
}: IUseProjectStatsParamsProps) => useContext(ProjectStatsContext)[timeframe];
